import type { ModuleDefinition } from '../../../../app/moduleRegistry';
import { isFeatureEnabled } from '../../../../config/featureFlags';
import SiteListPage from './pages/SiteListPage';
import SiteDetailPage from './pages/SiteDetailPage';

/** CMS: Site Ayarları — Master-GSA-only, gated behind the `HasCmsB2C` feature flag (same
 *  gating precedent as modules/system/index.tsx). Confirmed via local-backend swagger + live
 *  curl (see api/types/cmsSite.ts). Root of the CMS-Site hierarchy and the ONLY entry point
 *  in the sidebar for the whole B2C Yönetimi group: the other 10 sub-modules (Header/
 *  SiteTitle/Slider/Contact/About/Contract in this directory, plus City/PopulerCity/
 *  CheapestDestination/Destination/Campaign in the sibling `cms/content`) no longer have
 *  their own menu item — selecting "Yönet" on a site row here navigates to `cms/site/:siteId`
 *  (`SiteDetailPage`), which renders all of them as tabs scoped to that one site. */
export const siteModule: ModuleDefinition = {
  routes: [
    { path: 'cms/site', element: <SiteListPage /> },
    { path: 'cms/site/:siteId', element: <SiteDetailPage /> },
  ],
  menuItems: [
    {
      label: 'CMS Site: Site Ayarları',
      path: 'cms/site',
      isVisible: (user) => !!user?.isMasterGsa && isFeatureEnabled('HasCmsB2C'),
    },
  ],
};
